var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5828 19.1871C21.5828 21.8332 17.2924 23.9785 12 23.9785C6.70758 23.9785 2.41722 21.8332 2.41722 19.1871L2.41722 14.3646C3.01879 15.1031 3.87255 15.7168 4.82219 16.1915C6.70556 17.1333 9.24456 17.6898 12 17.6898C14.7554 17.6898 17.2945 17.1333 19.1779 16.1915C20.1275 15.7168 20.9812 15.1031 21.5828 14.3646L21.5828 19.1871Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5027C14.7554 10.5027 17.2945 9.94617 19.1779 9.00448C20.1275 8.52966 20.9812 7.91605 21.5828 7.17743L21.5828 12C21.5828 12.5989 19.4438 13.9059 18.3742 14.5845C16.7894 15.377 14.537 15.893 12 15.893C9.46302 15.893 7.21062 15.377 5.62573 14.5845C4.21399 13.8786 2.41722 12.5989 2.41722 12L2.41722 7.17743C3.01879 7.91605 3.87255 8.52966 4.82219 9.00448C6.70556 9.94617 9.24456 10.5027 12 10.5027Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3742 7.3974C16.7894 8.18985 14.537 8.70592 12 8.70592C9.46302 8.70592 7.21062 8.18985 5.62573 7.3974C5.00917 7.15586 3.6227 6.38799 2.65859 5.14754C2.49453 4.93645 2.42412 4.66742 2.46499 4.40323C2.49248 4.2256 2.53078 4.04264 2.57987 3.92922C3.40922 1.70515 7.31139 0.0215296 12 0.0215296C16.6886 0.0215296 20.5907 1.70515 21.4201 3.92922C21.4692 4.04264 21.5076 4.2256 21.535 4.40323C21.5758 4.66742 21.5055 4.93645 21.3414 5.14754C20.3773 6.38799 18.9909 7.15586 18.3742 7.3974Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.b20fd090a7436e6c06ee040c0219ba7b.svg";
export { ForwardRef as ReactComponent };